/**
 * Created by admin on 2017/3/23.
 */
import {
    GetProductByPage,
    GetProductExport,
    ProductDel,
    ProductUnEnable
} from '@api/productApi.js';
import { GetParmConfig, GetProductClass } from '@api/commonApi.js';
import { cloneDeep, util, isCorrectVal, isDate, lg } from 'utils';

module.exports = {
    created: function() {
        this.getList();
        this.getCategory();
        this.getClass();
    },
    data() {
        return {
            Session: util.getSessin(),
            loading2: false,
            orderBy: 'ProductId desc',
            pageIndex: 1,
            pageSize: 10,
            totalSize: '',
            pageSizes: [10, 20, 50],
            sels: [], //列表选中列
            roleDialog: false, //弹出层
            loadingTable: false, //table加载
            List: [], //table列表a
            loading2: false,
            query: {
                productId: "",
                productName: "",
                productClass: "",
                productCategory: "",
            },
            Category: [{
                Id: "All",
                ParmName: "全部"
            }],
            ProductClass: [{
                Key: "全部",
                Value: "All"
            }],
        }
    },

    methods: {
        handleEdit(index, item) {
            util.redirect(this, '/productInformation/productControl/addProduct?Id=' + item.ProductId, true);
        },
        ProVisit(index, item) {
            util.redirect(this, '/productInformation/productControl/addProduct?Id=' + item.ProductId + '&view=true', true);
        },
        getList: function() {
            this.search();
        },
        getCategory: function() {
            var Params = {
                Sid: this.Session[0],
                Session: this.Session[1],
                ParmType: 1
            };
            GetParmConfig(Params).then(res => {
                util.doResult(this, res, () => {});
                if (res.data.StateCode !== 0) {
                    if (res.data.StateCode == 99) {
                        this.$router.push('/login')
                    } else {
                        this.$notify({
                            title: '错误',
                            message: res.data.StateMsg,
                            type: 'error'
                        });
                    }
                } else {
                    for (var i = 0; i < res.data.Data.length; i++) {
                        this.Category.push(res.data.Data[i])
                    }

                }
            })
        },
        getClass: function() {
            var Params = {
                Sid: this.Session[0],
                Session: this.Session[1]
            };
            GetProductClass(Params).then(res => {
                util.doResult(this, res, () => {});
                if (res.data.StateCode !== 0) {
                    if (res.data.StateCode == 99) {
                        this.$router.push('/login')
                    } else {
                        this.$notify({
                            title: '错误',
                            message: res.data.StateMsg,
                            type: 'error'
                        });
                    }
                } else {
                    for (var i = 0; i < res.data.Data.length; i++) {
                        this.ProductClass.push(res.data.Data[i])
                    }
                }
            })
        },
        search: function() {
            this.List = [];
            var Params = {
                Sid: this.Session[0],
                Session: this.Session[1],
                pageIndex: this.pageIndex,
                pageSize: this.pageSize
            };
            if (this.query.productId != "") {
                Params.ProCode = this.query.productId;
            }
            if (this.query.productName != "") {
                Params.ProName = this.query.productName;
            }
            if (this.query.productClass != "" && this.query.productClass != "All") {
                Params.ProClass = this.query.productClass;
            }
            if (this.query.productCategory != "" && this.query.productCategory != "All") {
                Params.ProCategory = this.query.productCategory;
            }
            this.loading2 = true;
            GetProductByPage(Params).then(res => {
                util.doResult(this, res, () => {
                    this.totalSize = res.data.Cnt;
                    this.List = res.data.Data;
                    this.loading2 = false;
                })
            })
        },
        download: function() {
            this.$confirm('确认导出吗？', '提示', {}).then(() => {

                var ids = this.sels.map(item => item.ProductId).toString();
                if (ids == "") {
                    this.search();
                    var Params = {
                        Sid: this.Session[0],
                        Session: this.Session[1]
                    };
                    if (this.query.productId != "") {
                        Params.ProCode = this.query.productId;
                    }
                    if (this.query.productName != "") {
                        Params.ProName = this.query.productName;
                    }
                    if (this.query.productClass != "" && this.query.productClass != "All") {
                        Params.ProClass = this.query.productClass;
                    }
                    if (this.query.productCategory != "" && this.query.productCategory != "All") {
                        Params.ProCategory = this.query.productCategory;
                    }
                } else {
                    var Params = {
                        Sid: this.Session[0],
                        Session: this.Session[1]
                    };
                    Params.ids = ids;
                }

                GetProductExport(Params).then(res => {
                    let {
                        StateCode,
                        StateMsg,
                        Data,
                        Cnt
                    } = res.data;
                    util.doResult(this, res, () => {
                        try {

                            var elemIF = document.createElement("iframe");
                            elemIF.src = Data;
                            elemIF.style.display = "none";
                            document.body.appendChild(elemIF);
                        } catch (e) {
                            this.$notify({
                                title: '浏览器不兼容，建议使用谷歌浏览器',
                                type: 'error'
                            });
                        }
                    })
                })
            })
        },
        addProduct: function() {
            util.redirect(this, '/productInformation/productControl/addProduct');
        },
        delProduct: function(index, row) {
            this.$confirm('确认删除吗？', '提示', {}).then(() => {
                /* var ids = this.sels.map(item => item.ProductId).toString();*/
                var ids = row.ProductId;
                var Params = {
                    Ids: ids
                };
                ProductDel(Params).then(res => {
                    let {
                        StateCode,
                        StateMsg,
                        Data,
                        Cnt
                    } = res.data;
                    util.doResult(this, res, () => {
                        this.$notify({
                            title: '成功',
                            message: "删除成功",
                            type: 'success'
                        });
                        this.getList()
                    })
                })
            })
        },
        forbidden: function(index, row) {
            this.$confirm('确认禁用吗？', '提示', {}).then(() => {
                /* var ids = this.sels.map(item => item.ProductId).toString();*/
                var ids = row.ProductId;
                var Params = {
                    Ids: ids
                };
                ProductUnEnable(Params).then(res => {
                    let { StateCode, StateMsg, Data, Cnt } = res.data;
                    util.doResult(this, res, () => {
                        this.$notify({
                            title: '成功',
                            message: "禁用成功",
                            type: 'success'
                        });
                        this.getList()
                    })
                })
            })
        },
        handleSizeChange: function(val) {
            this.pageSize = val;
            this.getList();
        }, //分页选定行
        handleCurrentChange: function(val) {
            this.pageIndex = val;
            this.getList();
        }, //分页监听页面
        selsChange: function(sels) {
            this.sels = sels;
        },
    },
    watch: {
        $route: function() {
            if (this.$route.name == '单品管理') {
                this.getList();
            }
        }
    },
}


// WEBPACK FOOTER //
// ./src/pages/productInformation/productControl.js